import Container from '@/container';
import {Col, Grid, Row} from '@/grid';
import {withBgNeutral100} from '@/hocs/withColors';
import {withMarginBottom2xl, withMarginBottomSm} from '@/hocs/withSpacing';
import {SectionPadding} from '@/section';
import {H2} from '@/typography';
import Pill from '@/ui/pills';
import Steps from '@/ui/steps';

const DivMargined2xl = withMarginBottom2xl('div');
const PillMargined = withMarginBottomSm(Pill);
const SectionBgNeutral100 = withBgNeutral100(SectionPadding);

const HowToJoin = [
  {
    title: 'Sign up',
    copy: 'Complete a short form to express your interest in the program. A member of the partnerships team will get in touch to explore the fit.'
  },
  {
    title: 'Get onboarded',
    copy: 'Go through a quick approval process and receive everything needed to get started.'
  },
  {
    title: 'Drive impact',
    copy: 'Start referring startups using our lead form and your unique referral code to give them access to powerful hiring tools, while adding value to your network and supporting early-stage growth.'
  }
];

const GettingStarted = () => (
  <SectionBgNeutral100>
    <Container>
      <Grid fluid>
        <DivMargined2xl>
          <Row center="xs">
            <Col xs={12} lg={8}>
              <PillMargined variant="neutral900">Getting started</PillMargined>
              <H2>Here’s how to join the program and refer with ease</H2>
            </Col>
          </Row>
        </DivMargined2xl>
        <Steps stepsContent={HowToJoin} />
      </Grid>
    </Container>
  </SectionBgNeutral100>
);

export default GettingStarted;
